// API Configuration
// Uses environment variable in production, localhost in development
export const getApiUrl = () => {
  // In production, use the backend URL from environment variable
  if (import.meta.env.PROD) {
    return import.meta.env.VITE_API_URL || 'https://apilabely.esire.org';
  }
  // In development, use localhost
  return import.meta.env.VITE_API_URL || 'http://localhost:3001';
};

export const API_URL = getApiUrl();

// Helper function to create full API endpoint URLs
export const createApiUrl = (endpoint: string) => {
  // Remove leading slash if present
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${API_URL}/${cleanEndpoint}`;
};

export default API_URL;
